/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/react'
import styled from '@emotion/styled'
import { Placement } from '@popperjs/core'
import { usePopperTooltip } from 'react-popper-tooltip'

import IconQuestionmark from '../svg/IconQuestionmark'

// import 'react-popper-tooltip/dist/styles.css'

const TooltipDiv = styled.div(
  ({ theme }) => theme.fontSmooth,
  ({ theme }) => ({
    backgroundColor: theme.colors.white,
    borderRadius: theme.borders.card.borderRadius,
    padding: '16px',
    color: theme.colors.text,
    fontFamily: theme.fonts.families.body,
    fontSize: '14px',
    fontWeight: 'normal',
    letterSpacing: '0.35px',
    lineHeight: '18px',
    boxShadow: '0px 3px 6px #00000029',
    zIndex: 999,
  })
)

interface Props {
  hideArrow?: boolean
  tooltip: React.ReactNode
  placement?: Placement
  className?: string
  children?: React.ReactNode
}

const Tooltip: React.FC<Props> = ({
  children,
  tooltip,
  hideArrow,
  ...props
}) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip()

  return (
    <div css={{ display: 'inline-block' }}>
      <span ref={setTriggerRef}>
        {!!children ? children : <IconQuestionmark size={20} variant="link" />}
      </span>

      {visible && (
        <TooltipDiv
          ref={setTooltipRef}
          {...getTooltipProps({ className: 'tooltip-container' })}
        >
          <div {...getArrowProps({ className: 'tooltip-arrow' })} />
          {tooltip}
        </TooltipDiv>
      )}
    </div>
  )
}

export default Tooltip
